import type { BoardStatus } from '@mm/shared';

export const STATUS_LABEL: Record<BoardStatus, string> = {
  NEW: 'Новое',
  VIEWED: 'Открыто',
  WORKING: 'В работе',
  FINISHED: 'Ждёт проверки',
  REVIEWED: 'Проверено',
};

export function formatTimeSpent(sec: number): string | null {
  if (sec <= 0) return null;
  const m = Math.round(sec / 60);
  if (m < 60) return `${m} мин`;
  const h = Math.floor(m / 60);
  const rest = m % 60;
  return rest === 0 ? `${h} ч` : `${h} ч ${rest} мин`;
}

export function formatDue(dueAt: string | null): string | null {
  if (!dueAt) return null;
  const d = new Date(dueAt);
  return d.toLocaleDateString('ru', { day: 'numeric', month: 'short' });
}

// Date input accepts YYYY-MM-DD local; server stores as ISO datetime.
export function dueInputValue(dueAt: string | null): string {
  if (!dueAt) return '';
  const d = new Date(dueAt);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function inputToDueIso(v: string): string | null {
  if (!v) return null;
  const d = new Date(`${v}T23:59:59`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

// Youtube / Rutube / Vimeo → embed URL. Возвращает null если не распознан.
export function videoEmbedUrl(url: string): string | null {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      const id = u.pathname.slice(1).split('/')[0];
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (host === 'youtube.com' || host === 'm.youtube.com') {
      if (u.pathname === '/watch') {
        const id = u.searchParams.get('v');
        return id ? `https://www.youtube.com/embed/${id}` : null;
      }
      if (u.pathname.startsWith('/embed/')) return url;
      if (u.pathname.startsWith('/shorts/')) {
        const id = u.pathname.split('/')[2];
        return id ? `https://www.youtube.com/embed/${id}` : null;
      }
    }
    if (host === 'rutube.ru') {
      // /video/<id>/ or /play/embed/<id>
      const m = u.pathname.match(/^\/(?:video|play\/embed)\/([^/]+)/);
      return m ? `https://rutube.ru/play/embed/${m[1]}` : null;
    }
    if (host === 'vimeo.com') {
      const id = u.pathname.split('/').filter(Boolean).pop();
      return id && /^\d+$/.test(id) ? `https://player.vimeo.com/video/${id}` : null;
    }
    if (host === 'player.vimeo.com') return url;
    return null;
  } catch {
    return null;
  }
}
